module.exports = __webpack_public_path__ + "img/TBWTTNL_scribble_items.96d95b39.png";